import React from "react";
import { Tag, Tooltip } from "antd";
import { CheckCircleOutlined, LockOutlined } from "@ant-design/icons";

/**
 * SubscriptionBadge Component
 * Displays subscription status indicator for features using Ant Design filled Tags
 * 
 * @param {boolean} isAvailable - Whether the feature is available in current subscription
 * @param {string} requiredPlan - The subscription plan required to unlock this feature
 * @param {string} className - Additional CSS classes
 */
export const SubscriptionBadge = ({ 
  isAvailable = false, 
  requiredPlan = "Advanced",
  className = "" 
}) => {
  if (isAvailable) {
    return (
      <Tag 
        icon={<CheckCircleOutlined />}
        color="success"
        style={{ 
          fontWeight: 600,
          fontSize: "11px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          margin: 0,
          borderRadius: "6px",
          padding: "4px 10px",
          display: "flex",
          alignItems: "center",
          gap: "4px"
        }}
        className={className}
      >
        Active
      </Tag>
    );
  }

  const upgradeMessage = `Upgrade to ${requiredPlan} or higher to unlock this feature`;

  const handleUpgradeClick = (e) => {
    e.stopPropagation();
    window.open("https://code-cube.io/pricing/", "_blank", "noopener,noreferrer");
  };

  return (
    <Tooltip title={upgradeMessage} placement="left">
      <Tag 
        icon={<LockOutlined />}
        color="default"
        onClick={handleUpgradeClick}
        style={{ 
          fontWeight: 600,
          fontSize: "11px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          margin: 0,
          cursor: "pointer",
          borderRadius: "6px",
          padding: "4px 10px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          pointerEvents: "auto"
        }}
        className={className}
      >
        Upgrade
      </Tag>
    </Tooltip>
  );
};

export default SubscriptionBadge;
